import React, { useState, useEffect } from 'react';
import { usePermissionContext } from '../contexts/PermissionContext';
import API_BASE_URL from '../config/apiConfig';
import { getFileUrl } from '../utils/api.js';
import superLogo from '../assets/images/super_logo.webp';

function WelcomePage() {
  const { company } = usePermissionContext();
  const [userData, setUserData] = useState(null);
  const [companyData, setCompanyData] = useState(null);

  useEffect(() => {
    const userStr = sessionStorage.getItem('user');
    if (userStr) {
      try {
        const parsedUser = JSON.parse(userStr);
        setUserData(parsedUser);

        if (parsedUser.role?.toUpperCase() !== 'SUPER_ADMIN' && (parsedUser.company_id || parsedUser.companyId)) {
          fetchCompanyData(parsedUser.company_id || parsedUser.companyId);
        }
      } catch (error) {
        console.error('Error parsing user data:', error);
      }
    }
  }, []);

  const fetchCompanyData = async (companyId) => {
    try {
      const token = sessionStorage.getItem('token');
      const response = await fetch(`${API_BASE_URL}/company/${companyId}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        setCompanyData(data);
      }
    } catch (error) {
      console.error('Error fetching company data:', error);
    }
  };

  const isSuperAdmin = userData?.role?.toUpperCase() === 'SUPER_ADMIN';
  const logoPath = isSuperAdmin ? null : (companyData?.companyLogoImage || company?.companyLogoImage || companyData?.company_logo_image || company?.company_logo_image);
  const logoSrc = logoPath ? getFileUrl(logoPath) : superLogo;
  
  const compName = isSuperAdmin ? 'Super Admin' : (companyData?.companyName || companyData?.company_name || company?.companyName || company?.company_name || 'Asensia');

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '70vh',
      textAlign: 'center',
      padding: '20px',
      fontFamily: 'Inter, system-ui, -apple-system, sans-serif'
    }}>
      <img 
        src={logoSrc} 
        alt="Company Logo" 
        style={{ 
          maxWidth: '280px', 
          height: 'auto', 
          marginBottom: '24px'
        }} 
      />
      <h1 style={{
        fontSize: '28px',
        fontWeight: '700',
        color: '#0f172a',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '10px'
      }}>
        Welcome to {compName} 👋
      </h1>
    </div>
  );
}

export default WelcomePage;
